import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {User} from "@/types/User.tsx";

interface CoachState {
    coaches: User[];
    loading: boolean;
    error: string | null;
}

const initialState: CoachState = {
    coaches: [],
    loading: false,
    error: null,
};

const coachesSlice = createSlice({
    name: "coaches",
    initialState,
    reducers: {
        // Add a new coaches to the state array
        addCoaches(state, action: PayloadAction<User>) {
            state.coaches.push(action.payload);
        },

        // Remove an existing player by id
        removeCoache(state, action: PayloadAction<number>) {
            state.coaches = state.coaches.filter(
                (player) => player.id !== action.payload
            );
        },

        // Update an existing player by matching on id
        updateCoache(state, action: PayloadAction<User>) {
            const updated = action.payload;
            const index = state.coaches.findIndex((p) => p.id === updated.id);
            if (index !== -1) {
                state.coaches[index] = updated;
            }
        },

        setCoaches(state, action: PayloadAction<User[]>) {
            state.coaches = action.payload;
        },
    },
});

export const {
    addCoaches,
    removeCoache,
    updateCoache ,
    setCoaches,
} = coachesSlice.actions;
export default coachesSlice.reducer;